@if (content) {
  <modal-layout-middle
    (close)="close()"
    [sideImage]="contentVariant?.image || ''">
    <!-- title -->
    <p class="h3 m-t-5 m-t-8-s"
    *iCms="'viewAllCopy' of contentVariant"></p>
    <!-- subtitle 1 -->
    <p class="p1 m-t-5"
    *iCms="'subtitle1' of contentVariant; content 'html'"></p>
    <!-- subtitle 2 -->
    <p class="p1 m-t-5"
      *iCms="'subtitle2' of contentVariant"
    html></p>
    <!-- go to default -->
    <button class="w-12 m-t-5 m-t-8-s button"
      [buttonStyle]
      (click)="confirm()">
      <span class="button__body"
      *iCms="'confirmButtonCopy' of contentVariant"></span>
    </button>
    <!-- stay on website -->
    <button class="w-12 m-t-2 m-t-3-s"
      buttonStyle="button-1"
      (click)="stay()">
      <span class="button__body"
      *iCms="'closeButtonCopy' of contentVariant"></span>
    </button>
    <!-- view all -->
    <button class="m-t m-t-3-s m-b-5 m-b-4-s text s1"
      (click)="viewAll()">
      <span class="link"
      *iCms="'viewAllCopy' of contentVariant"></span>
    </button>
  </modal-layout-middle>
}
